import { ESdChangeReason, IConditionModel } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { Comparison } from "./condition";

export interface IValidationConditionState {
  active: boolean;
}

export interface IValidationConditionProps {
  condition?: IConditionModel;
  onChange?: (condition?: IConditionModel, changeReason?: ESdChangeReason | undefined) => void;
  dontShowRemoveCondition?: boolean;
}

class ValidationCondition extends PureSdComponent<
  IValidationConditionProps & IWithSDProps & IWithContextProp,
  IValidationConditionState
> {
  constructor(props: IValidationConditionProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  handleRemoveCondition = () => {
    if (this.props.onChange) {
      this.props.onChange(undefined);
    }
  };

  render() {
    return (
      <>
        {this.props.condition && (
          <>
            <Comparison
              condition={this.props.condition}
              onChange={this.props.onChange}
              conditionType="validationCondition"
            />
          </>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.UpdateValidation ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.ActionParameterFixedValueChanged
    ) {
      return true;
    }
    return false;
  };
}

const validationCondition = withContext<IValidationConditionProps>(
  withSD<IValidationConditionProps>(ValidationCondition)
);
export { validationCondition as ValidationCondition };
